const KEY = 'polka.yandex.oauth';

export function startYandexOAuth(clientId, redirectUri) {
  const state = crypto.randomUUID();
  sessionStorage.setItem(KEY, JSON.stringify({ state, createdAt: Date.now() }));
  const url = new URL('https://oauth.yandex.ru/authorize');
  url.search = new URLSearchParams({ response_type: 'code', client_id: clientId, redirect_uri: redirectUri, state });
  return url.href;
}

export function consumeYandexState(state) {
  const raw = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  try {
    const stored = JSON.parse(raw);
    return !!state && stored?.state === state && Date.now() - stored.createdAt >= 0 && Date.now() - stored.createdAt < 10 * 60000;
  } catch { return false; }
}
